// extracted by mini-css-extract-plugin
export default {"text":"HomeMenuBtnSubText_text__Or2bP"};